import React from 'react'
import P2PWalletTransfer from '../../Component/WalletTransfer/P2PWalletTransfer/P2PWalletTransfer'

const P2PTransfer = () => {
  return (
    <div className='page-body'><P2PWalletTransfer/></div>
  )
}

export default P2PTransfer